<script setup>
/** 创建公会引导：和新手引导是同一个页面，只是步骤换成开公会要走的那些。 */
import OnboardingPage from './OnboardingPage.vue'
</script>

<template>
  <OnboardingPage mode="create" />
</template>
